/* global window */

import React, { useEffect, useRef, useState } from 'react';
import FeatureListItem from './FeatureListItem';
import '../styles/FeatureList.css';
import { array, bool } from 'prop-types';

export default function FeatureList({ isMobile, features = [] }) {
    const featureListRef = useRef(null);
    const [selected, setSelected] = useState(0);
    const [isSwitching, setIsSwitching] = useState(false);
    const [startX, setStartX] = useState(0);
    const [offsetXPercent, setOffsetXPercent] = useState(0);
    const ITEMS_PER_VIEW = 2;
    const WIDTH_ADJUSTMENT = features.length / ITEMS_PER_VIEW;
    useEffect(() => {
        /* Manual switch */
        setOffsetXPercent(0);
        const handleTouchMove = (e) => {
            if (isMobile === true && isSwitching === true) {
                const newX = e.touches[0].clientX;
                const featureListWidth = Math.floor(featureListRef.current.offsetWidth / features.length);
                // Check difference
                const diffX = (newX - startX);
                const newOffsetXPercent = Math.floor(diffX / featureListWidth * 100);
                const SWITCH_DIFF_PERCENT = 15;
                if (newOffsetXPercent > SWITCH_DIFF_PERCENT) {
                    setSelected((selected - 1) >= 0 ? (selected - 1) : (features.length - 1));
                    setIsSwitching(false);
                } else if (newOffsetXPercent <= -SWITCH_DIFF_PERCENT) {
                    setSelected((selected + 1) < features.length ? (selected + 1) : 0);
                    setIsSwitching(false);
                } else {
                    setOffsetXPercent(newOffsetXPercent * 2.04);
                }
            }
        };
        window.addEventListener('touchmove', handleTouchMove);
        return () => {
            window.removeEventListener('touchmove', handleTouchMove);
        };
    }, [selected, isSwitching, features, isMobile]);
    const handleTouchStart = (e) => {
        e.preventDefault();
        if (!isMobile) 
            return;
        setIsSwitching(true);
        setOffsetXPercent(0);
        setStartX(e.touches[0].clientX);
    };
    const handleTouchEnd = (e) => {
        if (!isMobile) 
            return;
        setIsSwitching(false);
    };
    return (<div
        className={'feature-list p-lg-4'}>
        <div
            ref={featureListRef}
            className={'feature-list--inner'}
            style={{
                ...isMobile && ({
                    width: `${WIDTH_ADJUSTMENT * 100}%`,
                    left: `${Math.floor(-(selected * (WIDTH_ADJUSTMENT / features.length * 100)) + offsetXPercent)}%`,
                })
            }}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >
            {features.map((feature, idx) => (<FeatureListItem
                key={idx}
                isMobile={isMobile}
                heading={feature.heading}
                text={feature.text}
                link={feature.link}
                Icon={feature.Icon}
                featureWidth={(WIDTH_ADJUSTMENT / features.length * 100)} />))}
        </div>
    </div>);
}

FeatureList.propTypes = {
    isMobile: bool,
    features: array,
};